import FlyersContext from '@/context/FlyersContext';
import { useContext } from 'react';
import { useNavigate } from 'react-router-dom';

export const useNavigationPreviousPage = () => {
  const navigate = useNavigate();
  const { activeTab } = useContext(FlyersContext);
  const goToPreviousPage = () => {
    if (window.history.state && window.history.state.idx > 0) {
      navigate(-1);
    } else {
      navigate(`/?tab=${activeTab}`, { replace: true });
    }
  };
  return goToPreviousPage;
};
